import { render, staticRenderFns } from "./ViewEmployeeModal.vue?vue&type=template&id=70e68e09&scoped=true&"
import script from "./ViewEmployeeModal.vue?vue&type=script&lang=js&"
export * from "./ViewEmployeeModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewEmployeeModal.vue?vue&type=style&index=0&id=70e68e09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e68e09",
  null
  
)

component.options.__file = "ViewEmployeeModal.vue"
export default component.exports